import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from 'app/shared/components/Notistack/Notistack';
import { EC_SERVICE } from 'app/shared/constants/apiConfig';
import { ISmsSend } from './interfaces';

const path = `${EC_SERVICE.ENTERPRISECOMMUNICATION}`;

export const requestSendSms = (data: ISmsSend) => {
  const url = `${path}/sms/send`;
  return mutate(url, async() => {
    try {
      const resp = await axios.post(url, data);
      Notistack.infoMessage(' Message Sent');
      return resp;
    } catch (err) {
      const error = err as { response: { data: { message: string } } };
      Notistack.generalError(error?.response?.data?.message);
      return err;
    }
  });
};
